import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { RouterProvider } from "@tanstack/react-router";

import { indexedDbPersister } from "../data/cache-persistence/persister";
import { queryClient } from "../data/query-client/queryClient";
import { OrdersRuntimeProvider } from "../features/orders/runtime/OrdersRuntimeProvider";
import { AuthProvider } from "./providers/AuthProvider";
import { router } from "./router/router";

export function App() {
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister: indexedDbPersister,
        // Keep the locally encrypted browser cache available between workdays.
        // It is reconciled in the background after authentication.
        maxAge: 30 * 24 * 60 * 60 * 1000,
        buster: "eurocut-erp-v3-snapshot",
        dehydrateOptions: {
          shouldDehydrateQuery: (query) =>
            query.state.status === "success" &&
            ["orders", "backups"].includes(String(query.queryKey[0])),
        },
      }}
    >
      <AuthProvider>
        <OrdersRuntimeProvider>
          <RouterProvider router={router} />
        </OrdersRuntimeProvider>
      </AuthProvider>
    </PersistQueryClientProvider>
  );
}
